var _rect, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGrayThreeDots = function SvgGrayThreeDots(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "more_vert"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7573_4251",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 24.6625,
    width: 24,
    height: 24,
    transform: "rotate(-90 0 24.6625)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7573_4251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "more_vert_2",
    d: "M20 12.6625C20 13.2125 19.8043 13.6831 19.413 14.0745C19.021 14.4665 18.55 14.6625 18 14.6625C17.45 14.6625 16.979 14.4665 16.587 14.0745C16.1957 13.6831 16 13.2125 16 12.6625C16 12.1125 16.1957 11.6415 16.587 11.2495C16.979 10.8581 17.45 10.6625 18 10.6625C18.55 10.6625 19.021 10.8581 19.413 11.2495C19.8043 11.6415 20 12.1125 20 12.6625ZM14 12.6625C14 13.2125 13.804 13.6831 13.412 14.0745C13.0207 14.4665 12.55 14.6625 12 14.6625C11.45 14.6625 10.979 14.4665 10.587 14.0745C10.1957 13.6831 10 13.2125 10 12.6625C10 12.1125 10.1957 11.6415 10.587 11.2495C10.979 10.8581 11.45 10.6625 12 10.6625C12.55 10.6625 13.0207 10.8581 13.412 11.2495C13.804 11.6415 14 12.1125 14 12.6625ZM8 12.6625C8 13.2125 7.804 13.6831 7.412 14.0745C7.02067 14.4665 6.55 14.6625 6 14.6625C5.45 14.6625 4.97933 14.4665 4.588 14.0745C4.196 13.6831 4 13.2125 4 12.6625C4 12.1125 4.196 11.6415 4.588 11.2495C4.97933 10.8581 5.45 10.6625 6 10.6625C6.55 10.6625 7.02067 10.8581 7.412 11.2495C7.804 11.6415 8 12.1125 8 12.6625Z",
    fill: "#1E323C"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrayThreeDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GrayThreeDots.7740187c.svg";
export { ForwardRef as ReactComponent };